import { render } from "./Example2.vue?vue&type=template&id=7e1fe6aa"
import script from "./Example2.vue?vue&type=script&lang=ts"
export * from "./Example2.vue?vue&type=script&lang=ts"
script.render = render

export default script